const emptyTiptapDoc = {
  type: 'doc',
  content: [
    {
      type: 'paragraph',
      content: [],
    },
  ],
}

const removeEmptyTextNodes = (node) => {
  if (!node || typeof node !== 'object') return node

  if (node.type === 'text' && typeof node.text === 'string' && !node.text) {
    return null
  }

  if (!Array.isArray(node.content)) return node

  return {
    ...node,
    content: node.content.map(removeEmptyTextNodes).filter(Boolean),
  }
}

const parseTiptapDoc = (value) => {
  if (value?.type === 'doc') {
    return value
  }

  if (typeof value !== 'string') {
    return null
  }

  try {
    const parsed = JSON.parse(value)

    return parsed?.type === 'doc' ? parsed : null
  } catch (error) {
    return null
  }
}

export const convertTextareaToTiptap = (text) => {
  if (typeof text !== 'string') {
    return emptyTiptapDoc
  }

  const lines = text.split('\n')

  if (lines.length === 1 && lines[0] === '') {
    return emptyTiptapDoc
  }

  return {
    type: 'doc',
    content: lines.map((line) => ({
      type: 'paragraph',
      content: line === '' ? [] : [{ type: 'text', text: line }],
    })),
  }
}

export const normalizeTiptapContent = (value) => {
  const tiptapDoc = parseTiptapDoc(value)

  if (tiptapDoc) {
    return removeEmptyTextNodes(tiptapDoc) ?? emptyTiptapDoc
  }

  return convertTextareaToTiptap(typeof value === 'string' ? value : '')
}

const hasNodeContent = (node) => {
  if (!node) {
    return false
  }

  if (typeof node.text === 'string' && node.text.trim().length > 0) {
    return true
  }

  if (Array.isArray(node.content) && node.content.some(hasNodeContent)) {
    return true
  }

  return Boolean(
    node.type &&
      !['doc', 'paragraph', 'heading', 'hardBreak', 'text'].includes(node.type),
  )
}

export const isTiptapContentEmpty = (value) => (
  !hasNodeContent(normalizeTiptapContent(value))
)

export const serializeTiptapContent = (value) => {
  if (isTiptapContentEmpty(value)) {
    return ''
  }

  return JSON.stringify(normalizeTiptapContent(value))
}
